import React from 'react';

const Play = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 20 20"
  >
    <path
      fill="#FFF"
      d="M15.282 11.34L2.554 19.727C1.469 20.444 0 19.664 0 18.378V1.625C0 .318 1.469-.44 2.554.276l12.728 8.387c.957.612.957 2.045 0 2.677z"
    />
  </svg>
);

export default Play;
